/* eslint-disable @typescript-eslint/no-empty-function */
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/Tooltip";
import uniqBy from "lodash/uniqBy";
import type { IGeographicalCountry, IGeographicalCountrySvgFlag } from "types/graphqlTypes";

export type GeographicalCountry = Omit<IGeographicalCountry, "__typename" | "flagSvg"> & {
  flagSvg: Omit<IGeographicalCountrySvgFlag, "__typename" | "squaredHref">;
};

// Countries we don't have the a flag for
const BLACKLISTED_COUNTRIES = ["IR"];

export function getFlagSvgUrl(isoCountryCode: string) {
  return `https://s.fndm.to/svg/common/flags/${isoCountryCode}.svg`;
}

interface GeographicalCountryStackProps {
  geographicalCountries: GeographicalCountry[];
  limit?: number;
  size?: number;
}

export default function GeographicalCountryStack({
  geographicalCountries,
  limit = 6,
  size = 24,
}: GeographicalCountryStackProps) {
  const countries = uniqBy(geographicalCountries, ({ isoCode }) => isoCode);
  if (countries.length === 0) {
    return null;
  }

  return (
    <div className="m-0 flex items-center -space-x-1">
      {countries
        .slice(0, limit)
        .filter((candidate) => {
          return BLACKLISTED_COUNTRIES.indexOf(candidate.isoCode) === -1;
        })
        .map((country) => {
          return (
            <TooltipProvider key={country.isoCode} delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild={true}>
                  <img
                    title={country.name}
                    alt={country.name}
                    src={country.flagSvg.ovalHref}
                    width={size}
                    height={size}
                    className="squircle"
                  />
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  sideOffset={12}
                  className="max-w-xs rounded-xl border border-transparent bg-black text-white"
                >
                  <strong className="font-bold">{country.name}</strong>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          );
        })}
    </div>
  );
}
